import { Column } from "react-data-grid";
import { Product } from "../../../../../global/types";
import AmountInput from "../../../../../presenters/AmountInput";

type ProductsTableArgs = {
  onAmountChange: (productId: number, amount: number) => void;
  handleNewRow: (key: string, value: number) => void;
};

const columns = ({
  onAmountChange,
  handleNewRow,
}: ProductsTableArgs): Column<Product>[] => [
  {
    name: "Artikel Nr.",
    key: "no",
  },
  {
    name: "Bezeichnung",
    key: "name",
  },
  {
    name: "Bestellungen",
    key: "total",
    headerCellClass: "centered",
    formatter: ({ row }) => (
      <p className='centered semi-bold'>{`${row.total}`.replace(/\./, ",")}</p>
    ),
  },
  {
    name: "Zu produzieren",
    key: "toProduce",
    headerCellClass: "centered",
    formatter: ({ row }) => (
      <AmountInput
        value={row.toProduce}
        onChange={(newValue) => handleNewRow(row.itemKey, newValue)}
      />
    ),
  },
  {
    name: "Produziert",
    key: "amount",
    headerCellClass: "centered",
    formatter: ({ row }) => (
      <AmountInput
        value={row.amount}
        onChange={(newAmount) => onAmountChange(row.id, newAmount)}
      />
    ),
  },
  {
    name: "Differenz",
    key: "differense",
    headerCellClass: "centered",
    formatter: ({ row }) => (
      <p className='centered semi-bold'>{row.amount - row.total}</p>
    ),
  },
];

export default columns;
